import { render, staticRenderFns } from "./QueueItem.vue?vue&type=template&id=3986040a&scoped=true&"
import script from "./QueueItem.vue?vue&type=script&lang=js&"
export * from "./QueueItem.vue?vue&type=script&lang=js&"
import style0 from "./QueueItem.vue?vue&type=style&index=0&id=3986040a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986040a",
  null
  
)

export default component.exports